import { request } from "@/api/server/index";

export default {
  //V001_契約データアップロード画面
  PolicyUpload: {
    //初期表示
    indexPolicyUpload(params) {
      return request({
        url: "/policyUpload/indexPolicyUpload",
        data: params,
        method: "post"
      });
    },
    //アップロード
    insertPolicyUploadFile(params) {
      let config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };
      return request({
        url: "/policyUpload/insertPolicyUploadFile",
        data: params,
        method: "post",
        config: config
      });
    },
    //アップロード解除
    deletePolicyUpload(params) {
      return request({
        url: "/policyUpload/deletePolicyUpload",
        data: params,
        method: "post"
      });
    }
  },
  // V019 証券情報
  policyEdit: {
    // 初期表示
    indexPolicyEdit(params) {
      return request({
        url: "/policyEdit/indexPolicyEdit",
        data: params,
        method: "post"
      });
    },
    // 証券情報 保険会社の値変更
    changeInsuranceCorp(params) {
      return request({
        url: "/policyEdit/changeInsuranceCorp",
        data: params,
        method: "post"
      });
    },
    // 証券情報 契約者の値変更
    changeContractor(params) {
      return request({
        url: "/policyEdit/changeContractor",
        data: params,
        method: "post"
      });
    },
    // 証券情報 カテゴリの値変更
    changeInsuranceCategoryCd(params) {
      return request({
        url: "/policyEdit/changeInsuranceCategoryCd",
        data: params,
        method: "post"
      });
    },
    // 証券情報 団体コードの値変更
    changeOrgId(params) {
      return request({
        url: "/policyEdit/changeOrgId",
        data: params,
        method: "post"
      });
    },
    //証券情報 保険種類の値変更
    changeMainProdCd(params) {
      return request({
        url: "/policyEdit/changeMainProdCd",
        data: params,
        method: "post"
      });
    },
    //証券情報 登録(新規登録)
    insertPolicyEdit(params) {
      return request({
        url: "/policyEdit/insertPolicyEdit",
        data: params,
        method: "post"
      });
    },
    //証券情報 登録(編集)
    updatePolicyEdit(params) {
      return request({
        url: "/policyEdit/updatePolicyEdit",
        data: params,
        method: "post"
      });
    },
    //証券情報 被保険者顧客選択 登録(新規登録)
    insertSelectPersonInsured(params) {
      return request({
        url: "/policyEdit/insertSelectPersonInsured",
        data: params,
        method: "post"
      });
    },

    //証券情報 削除
    deletePolicyEdit(params) {
      return request({
        url: "/policyEdit/deletePolicyEdit",
        data: params,
        method: "post"
      });
    },

    //特約登録画面（V019-1）の初期表示
    indexSpecialContractEdit(params) {
      return request({
        url: "/policyEdit/indexSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    //証券情報 特約 新規登録
    insertSpecialContractEdit(params) {
      return request({
        url: "/policyEdit/insertSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    //証券情報 特約 編集
    updateSpecialContractEdit(params) {
      return request({
        url: "/policyEdit/updateSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    //証券情報 特約 削除
    deleteSpecialContractEdit(params) {
      return request({
        url: "/policyEdit/deleteSpecialContractEdit",
        data: params,
        method: "post"
      });
    }
  },
  // V093 証券検索画面
  PolicySearch: {
    // 初期表示
    indexPolicySearch(params) {
      return request({
        url: "/policySearch/indexPolicySearch",
        data: params,
        method: "post"
      });
    },
    //主契約保険種類マスタの取得
    searchMainProdList(params) {
      return request({
        url: "/policySearch/searchMainProdList",
        data: params,
        method: "post"
      });
    },
    //検索（b1）をクリックしたときの処理
    searchPolicySearchList(params) {
      return request({
        url: "/policySearch/searchPolicySearchList",
        data: params,
        method: "post"
      });
    },
    //件数チェック
    checkCount(params) {
      return request({
        url: "/policySearch/checkCount",
        data: params,
        method: "post"
      });
    },
    //CSV出力
    outputCsv(params) {
      return request({
        url: "/policySearch/outputCsv",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    //一括変更（証券担当者）
    updateLifePolicyInsuranceSolicitorsCd(params) {
      return request({
        url: "/policySearch/updateLifePolicyInsuranceSolicitorsCd",
        data: params,
        method: "post"
      });
    },
    //一括変更（更改状況）
    updateLifePolicyRenewalStatus(params) {
      return request({
        url: "/policySearch/updateLifePolicyRenewalStatus",
        data: params,
        method: "post"
      });
    }
  },
  //V094_TNet契約種目データアップロード画面
  TNetContractItemDataUpload: {
    //初期表示
    indexTNetContractItemDataUpload(params) {
      return request({
        url: "/tNetContractItemDataUpload/indexTNetContractItemDataUpload",
        data: params,
        method: "post"
      });
    },
    //アップロード
    insertTNetContractItemDataUploadFile(params) {
      let config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };
      return request({
        url: "/tNetContractItemDataUpload/insertTNetContractItemDataUploadFile",
        data: params,
        method: "post",
        config: config
      });
    },
    //アップロード解除
    deleteTNetContractItemDataUpload(params) {
      return request({
        url: "/tNetContractItemDataUpload/deleteTNetContractItemDataUpload",
        data: params,
        method: "post"
      });
    }
  },
  // V095 損保証券情報
  policyEditSonpo: {
    // 初期表示
    indexPolicyEdit(params) {
      return request({
        url: "/policyEditSonpo/indexPolicyEdit",
        data: params,
        method: "post"
      });
    },
    // 保険会社の値変更
    changeInsuranceCorp(params) {
      return request({
        url: "/policyEditSonpo/changeInsuranceCorp",
        data: params,
        method: "post"
      });
    },
    // 契約者の値変更
    changeContractor(params) {
      return request({
        url: "/policyEditSonpo/changeContractor",
        data: params,
        method: "post"
      });
    },
    // カテゴリの値変更
    changeInsuranceCategoryCd(params) {
      return request({
        url: "/policyEditSonpo/changeInsuranceCategoryCd",
        data: params,
        method: "post"
      });
    },
    // 保険種類の値変更
    changeMainProdCd(params) {
      return request({
        url: "/policyEditSonpo/changeMainProdCd",
        data: params,
        method: "post"
      });
    },
    // 登録(新規登録)
    insertPolicyEdit(params) {
      return request({
        url: "/policyEditSonpo/insertPolicyEdit",
        data: params,
        method: "post"
      });
    },
    // 登録(編集)
    updatePolicyEdit(params) {
      return request({
        url: "/policyEditSonpo/updatePolicyEdit",
        data: params,
        method: "post"
      });
    },
    // 損保満期更改案件の存在チェック
    checkProposalExists(params) {
      return request({
        url: "/policyEditSonpo/checkProposalExists",
        data: params,
        method: "post"
      });
    },
    // 削除
    deletePolicyEdit(params) {
      return request({
        url: "/policyEditSonpo/deletePolicyEdit",
        data: params,
        method: "post"
      });
    },
  },
  //V097_更改後商品登録画面
  RenewalProductEdit: {
    //初期表示
    indexRenewalProductEdit(params) {
      return request({
        url: "/renewalProductEdit/indexRenewalProductEdit",
        data: params,
        method: "post"
      });
    },
    //主契約保険種類マスタの取得
    searchMainProdList(params) {
      return request({
        url: "/renewalProductEdit/searchMainProdList",
        data: params,
        method: "post"
      });
    },
    //登録（b3）をクリックしたときの処理(新規登録モード)
    insertRenewalProduct(params) {
      return request({
        url: "/renewalProductEdit/insertRenewalProduct",
        data: params,
        method: "post"
      });
    },
    //登録（b3）をクリックしたときの処理(編集モード)
    updateRenewalProduct(params) {
      return request({
        url: "/renewalProductEdit/updateRenewalProduct",
        data: params,
        method: "post"
      });
    },
    //削除（b2）をクリックしたときの処理
    deleteRenewalProduct(params) {
      return request({
        url: "/renewalProductEdit/deleteRenewalProduct",
        data: params,
        method: "post"
      });
    }
  }
};
